import { alpha, Box, Stack, Typography } from '@rossum/ui/material';
import { ReactNode } from 'react';

export const EmptyState = ({
  title,
  description,
}: {
  title: ReactNode;
  description: ReactNode;
}) => {
  return (
    <Box
      p={2}
      textAlign="center"
      sx={{
        width: '100%',
        border: theme => `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 1,
        backgroundColor: theme => alpha(theme.palette.grey[500], 0.1),
      }}
    >
      <Stack sx={{ opacity: 0.7 }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </Stack>
    </Box>
  );
};
